import { FC, useEffect, useMemo } from "react";
import { useDispatch } from "react-redux";
import { merge, pick } from "lodash-es";

import { editCurrentUser } from "Auth/state";
import { AUTH_ACTIONS } from "Auth/types";
import { useStateActionMeta } from "Auth/utils";
import { UserFlightPreferencesForm } from "Bands/components";
import { IBandUserFlightPreferences, UserSeatPreference } from "Bands/types";
import { useProfileContext } from "Auth/contexts";
import { useIsUserPreferenceFormSubmitted } from "Bands/utils";
import { IAPIState } from "shared/types";

interface Props {
  handleClose: (v: boolean) => void;
}

export const EditUserFlightPreferencesForm: FC<Props> = ({ handleClose }) => {
  const dispatch = useDispatch();
  const { userAttributes } = useProfileContext();

  const { status, error } = useStateActionMeta(AUTH_ACTIONS.editCurrentUser) || {};

  const handleSubmit = (data: IBandUserFlightPreferences) => {
    const { seatPreference } = data.flightPreferences || {};

    const cleanData: IBandUserFlightPreferences = merge({}, data, {
      flightPreferences: {
        seatPreference: seatPreference === UserSeatPreference.none ? null : seatPreference,
      },
    });

    setFormSubmitted(true);
    dispatch(editCurrentUser(cleanData));
  };

  const defaultValues = useMemo(() => {
    const { seatPreference } = userAttributes?.flightPreferences || {};

    return merge({}, pick(userAttributes, "flightPreferences"), {
      flightPreferences: {
        seatPreference: seatPreference === null ? UserSeatPreference.none : seatPreference,
      },
    });
  }, [userAttributes]);

  const { isFormSubmitted, setFormSubmitted } = useIsUserPreferenceFormSubmitted();

  useEffect(() => {
    if (status === IAPIState.succeeded) {
      handleClose(false);
    }
  });

  return (
    <UserFlightPreferencesForm
      defaultValues={defaultValues}
      handleSubmit={handleSubmit}
      apiError={isFormSubmitted ? error : undefined}
      error={isFormSubmitted ? !!error : undefined}
      apiStatus={isFormSubmitted ? status : undefined}
    />
  );
};
